// effects/products.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators'; // Import operators correctly
import { of } from 'rxjs';



import { Store } from '@ngrx/store';
import { ApiService } from 'src/app/shared/services/api.service';
import { ProjectsListActions, CurrentProjectLoadActions, createNewProjectActions, ProjectUpdateActions } from './projects.actions';
import { OutlineItem, ProjectItem } from 'src/app/shared/models/base.models';


@Injectable()
export class ProjectsEffects {

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private store: Store
  ) {

  }


  loadProjects$ = createEffect(() =>
  this.actions$.pipe(
    ofType(ProjectsListActions.load), // Listen for the loadProducts action
    mergeMap(() =>
      this.api.getProjects().pipe( // Use pipe method correctly within mergeMap
        map((response: {projects: ProjectItem[]}) => {
          return ProjectsListActions.loadSuccess({ projects: response.projects || [] });
        }),
        catchError((error) => of(ProjectsListActions.loadFailure({ error }))
      )
    )
  )
));


createNewProject$ = createEffect(() =>
  this.actions$.pipe(
    ofType(createNewProjectActions.create), // Listen for the loadProducts action
    mergeMap(({createPayload}) =>
  
      this.api.createProject(createPayload).pipe( // Use pipe method correctly within mergeMap
        map(({project}) => createNewProjectActions.createSuccess({ project: project })),
        catchError((error) => of(createNewProjectActions.createFailure({ error }))
      )
    )
  )
  ));



loadCurrentProject$ = createEffect(() =>
this.actions$.pipe(
  ofType(CurrentProjectLoadActions.load), // Listen for the loadProducts action
  mergeMap(({projectId}) =>
    this.api.getProjectById(projectId).pipe( // Use pipe method correctly within mergeMap
      map((response: {project: ProjectItem}) => CurrentProjectLoadActions.loadSuccess({ project: response.project })),
      catchError((error) => of(CurrentProjectLoadActions.loadFailure({ error }))
    )
  )
)
));

updateProject$ = createEffect(() =>
  this.actions$.pipe(
    ofType(ProjectUpdateActions.update), // Listen for the loadProducts action
    mergeMap(({projectId, payload}) =>
      this.api.updateProjectById(projectId, payload).pipe( // Use pipe method correctly within mergeMap
        map((response: {project: ProjectItem}) => ProjectUpdateActions.success({ project: response.project })),
        catchError((error) => of(ProjectUpdateActions.failure({ error }))
      )
    )
  )
  ));


}
